// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-fittingroom-js": () => import("./../../../src/pages/fittingroom.js" /* webpackChunkName: "component---src-pages-fittingroom-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-shop-js": () => import("./../../../src/pages/shop.js" /* webpackChunkName: "component---src-pages-shop-js" */),
  "component---src-pages-trackingpage-js": () => import("./../../../src/pages/trackingpage.js" /* webpackChunkName: "component---src-pages-trackingpage-js" */),
  "component---src-pages-virtualroom-js": () => import("./../../../src/pages/virtualroom.js" /* webpackChunkName: "component---src-pages-virtualroom-js" */)
}

